<div class="HomeShowList">
    <div class="sectionHeader">
        <div class="sectionTitleLeft">Series Channels</div>
    </div>
    <div class="sectionDivider"></div>

    <div class="homeShowListWrapper" appMySwipe (mySwipeLeft)="onSwipeLeft($event)" (mySwipeRight)="onSwipeRight($event)">
         <a class="showItem"  *ngFor="let item of data.showList" [routerLink]="item.url">
            <div class="imgHolder">
                <img [src]="item.thumb" alt="">
                <div class="border" *ngIf="!isMobile"></div>
            </div>
        </a>
    </div>
</div>
